export default __webpack_public_path__ + "8c804432e8c67741aac0392c54fc1961.woff";